import * as React from 'react';
import { Instance } from 'mobx-state-tree';
import { BlackPoint } from '../../store/models/BlackPoint';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import styled from '@emotion/styled';
import moment from 'moment';
import { ActionCode, Page, TLCode } from '../../common/enums';
import { DateWithDayStrFormat } from '../../store/utils';
import { BlackPointStatusCode } from '../../common/enums/BlackPointStatusCode';
import { Button, Icon, Intent, MenuItem } from '@blueprintjs/core';
import TranslatedMessage from '../common/translation/TranslatedMessage';
import { SelectInputFormField } from '../common/form';
import { IconNames } from '@blueprintjs/icons';
import { Form } from 'react-final-form';
import { toJS } from 'mobx';
import { IItemRendererProps } from '@blueprintjs/select';
import { BlackPointStatus } from '../../store/models/BlackPointStatus';
import { BlackPointSearchCriteria } from '../../store/BlackPointStore';
import { Link } from 'react-router-dom';

const PharmacyTitle = styled.h3`
  color: #137cbd;
  text-decoration: underline;
`;
const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  .bp3-button {
    margin-right: 3px;
  }
`;
const DivLeft = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;
  margin-right: 5%;
  border: black;
  border-style: solid;
  border-width: 1px;
  padding: 5px;
`;
const DivRight = styled.div`
  display: flex;
  flex-direction: column;
  border: black;
  border-style: solid;
  border-width: 1px;
  padding: 5px;
  .bp3-icon {
    margin-right: 3px;
  }
`;
const ContainerTileAndForm = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const Container = styled.div`
  padding: 5px 5px 5px 5px;
  margin-bottom: 10px;
  //border: gray;
  //border-style: solid;
  //border-width: 1px;
`;
const ContainerForm = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  & .bp3-form-group {
    margin: 0 0 2px;
  }
  & .bp3-button {
    min-height: 24px;
    padding: 0 3px;
  }
`;

interface BlackPointInfoProps extends WithTranslateProps {
  blackPoint: Instance<typeof BlackPoint>;
  changeStatus: (data: any) => void;
  statusList: Array<Instance<typeof BlackPointStatus>>;
  getStatusById: (id: number) => any;
  locale: string;
  searchCriteria: Instance<typeof BlackPointSearchCriteria>;
  backgroundColor: string;
  userRoles: string[];
}

class BlackPointDetails extends React.Component<BlackPointInfoProps> {
  renderStatusMenuItem(item: Instance<typeof BlackPointStatus>, { handleClick, index, modifiers }: IItemRendererProps) {
    if (modifiers.matchesPredicate) {
      return (
        <MenuItem key={`blackPointStatus-${index}`} active={modifiers.active} onClick={handleClick} text={item.name!} />
      );
    } else {
      return null;
    }
  }

  render() {
    const {
      blackPoint,
      translate,
      changeStatus,
      statusList,
      getStatusById,
      locale,
      searchCriteria,
      userRoles,
    } = this.props;
    const startDate = moment.utc(blackPoint.startDate).utc();
    const endDate = moment.utc(blackPoint.endDate).utc();
    const dif = endDate.endOf('day').diff(startDate.startOf('day'), 'days') + 1;
    const blackpointTitle =
      `${blackPoint.type ? blackPoint.type!.name : ''}, ${dif} ${translate(TLCode.BLACKPOINT_DETAIL_Days)}` +
      `( ${startDate.locale(locale).format(DateWithDayStrFormat)}` +
      ` - ${endDate.locale(locale).format(DateWithDayStrFormat)} )`;
    const statusCode = blackPoint.status != null ? blackPoint.status!.code : '';

    if (blackPoint) {
      return (
        <Container>
          <ContainerTileAndForm>
            <PharmacyTitle>{blackPoint.pharmacy != null ? blackPoint.pharmacy!.name : ''}</PharmacyTitle>
          </ContainerTileAndForm>
          <DivLine>
            {searchCriteria.pharmacyId === null && (
              <DivLeft>
                <span>{blackPoint.pharmacy ? blackPoint.pharmacy!.address : ''}</span>
              </DivLeft>
            )}
            <DivRight style={{ width: searchCriteria.pharmacyId ? '100%' : '65%' }}>
              {statusCode === BlackPointStatusCode.SUBMITTED && (
                <ContainerForm>
                  <Link to={Page.BlackPoints + '/' + blackPoint.blackPointId}>
                    <Button intent="primary" icon={IconNames.EDIT} small={true} />
                  </Link>
                  {(userRoles.includes(ActionCode.ADMIN_CODE) ||
                    userRoles.includes(ActionCode.SECRETARY_USER_CODE)) && (
                    <Form
                      initialValues={blackPoint}
                      onSubmit={changeStatus}
                      render={({ handleSubmit, dirty }) => (
                        <form onSubmit={handleSubmit}>
                          <DivLine>
                            <SelectInputFormField
                              name="blackPointStatusId"
                              inline={true}
                              items={toJS(statusList)}
                              itemValueGetter={(item: { blackPointStatusId: number; code: string }) =>
                                item.blackPointStatusId
                              }
                              valueItemGetter={(value: number) => getStatusById(value)!}
                              inputValueRenderer={(item) => (item != null ? item.name! : '')}
                              itemRenderer={this.renderStatusMenuItem}
                              identifier={'blackPointStatusId'}
                              elementLabel={'name'}
                            />
                            <div>
                              <Button
                                type={'submit'}
                                intent={Intent.PRIMARY}
                                icon={IconNames.FLOPPY_DISK}
                                disabled={!dirty}
                                small={true}
                              />
                            </div>
                          </DivLine>
                        </form>
                      )}
                    />
                  )}
                </ContainerForm>
              )}
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ fontWeight: 'bold' }}>{blackpointTitle}</span>
                <div>
                  {statusCode === BlackPointStatusCode.SUBMITTED && (
                    <div style={{ color: '#bf7326' }}>
                      <Icon icon={'help'} intent={'warning'} />
                      <TranslatedMessage id={TLCode.BLACKPOINT_DETAIL_Submitted} />
                    </div>
                  )}
                  {statusCode === BlackPointStatusCode.ACCEPTED && (
                    <div style={{ color: '#0d8050' }}>
                      <Icon icon={'thumbs-up'} intent={'success'} />
                      <TranslatedMessage id={TLCode.BLACKPOINT_DETAIL_Approuved} />
                    </div>
                  )}
                  {statusCode === BlackPointStatusCode.REJECTED && (
                    <div style={{ color: '#c23030' }}>
                      <Icon icon={'thumbs-down'} intent={'danger'} />
                      <TranslatedMessage id={TLCode.BLACKPOINT_DETAIL_Refused} />
                    </div>
                  )}
                </div>
              </div>
              <span>{blackPoint.comment}</span>
            </DivRight>
          </DivLine>
        </Container>
      );
    } else {
      return <div />;
    }
  }
}

export default withTranslate(BlackPointDetails);
